/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sn-img-dummy{opacity:0;height:0;width:0;visibility:hidden;display:block}.sn-img-main{width:100%;height:100%;transition:.5s filter linear,.5s -webkit-filter linear,-webkit-transform .3s ease-in-out;transition:.5s filter linear,.5s -webkit-filter linear,transform .3s ease-in-out;transition:.5s filter linear,.5s -webkit-filter linear,transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.blur{-webkit-filter:blur(10px);filter:blur(10px)}"];
export { styles as styles };
